import ActivitySVG from '@public/icons/icon-marketplace-planet-activity.svg'
import ItemsSVG from '@public/icons/icon-marketplace-planet-items.svg'
import SharedThirdNavBar, {
  NavigationItem
} from '@src/components/navigationBar/third/SharedThirdNavBar'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import { FC, useMemo } from 'react'

const OrbitalTrackThirdNavBar: FC<Props> = props => {
  const { index = 0 } = props

  const navigationItems: NavigationItem[] = useMemo(
    () => [
      {
        icon: ItemsSVG,
        route: ROUTE.MARKETPLACE_ORBITAL_TRACK_LIST,
        translationKey: 'sub_bar.marketplace.tabs.rent'
      },
      {
        icon: ActivitySVG,
        route: ROUTE.MARKETPLACE_ORBITAL_TRACK_ACTIVITY_LIST,
        translationKey: 'sub_bar.marketplace.tabs.activities'
      }
    ],
    []
  )

  return (
    <SharedThirdNavBar
      height={NAV_BAR_CONFIG.tertiary.height}
      index={index}
      navigationItems={navigationItems}
    />
  )
}

type Props = {
  index: number
}

export default OrbitalTrackThirdNavBar
